import React from 'react'
import { DataTable as BaseDataTable, createSortableHeader } from './ui/data-table'
import { ColumnDef } from '@tanstack/react-table'

interface DataTableProps {
  data: any[]
  columns: ColumnDef<any>[]
  title?: string
  loading?: boolean
  height?: number
  pageSize?: number
  disableExport?: boolean
  onRefresh?: () => void
  searchPlaceholder?: string
  compact?: boolean
  enableExport?: boolean
}

export function DataTable({
  data,
  columns,
  title,
  loading = false,
  height,
  pageSize = 10,
  disableExport = false,
  onRefresh,
  searchPlaceholder = "Buscar...",
  compact = false,
  enableExport,
}: DataTableProps) {
  return (
    <BaseDataTable
      data={data}
      columns={columns}
      title={title}
      loading={loading}
      onRefresh={onRefresh}
      searchPlaceholder={searchPlaceholder}
      enableExport={enableExport !== undefined ? enableExport : !disableExport}
      className={height ? `min-h-[${height}px]` : undefined}
      pageSize={pageSize}
      compact={compact}
    />
  )
}

// Export helper for creating sortable headers
export { createSortableHeader }